<script>
import { mapGetters } from 'vuex';
import AudioPlayer from '../components/AudioPlayer.vue';
import ImageViewer from '../components/ImageViewer.vue';
import AudioTrackSelect from '../components/AudioTrackSelect.vue';
import ExitStationButton from '../components/ExitStationButton.vue';
import InfoButton from '../components/InfoButton';
import InfoLabels from '../components/InfoLabels';

export default {
  name: 'PlayerPage',
  components: {
    AudioPlayer,
    ImageViewer,
    AudioTrackSelect,
    ExitStationButton,
    InfoButton,
    InfoLabels,
  },
  mounted() {
    this.$store.dispatch('startStation');
    this.setPosToCurrentTime();
    document.addEventListener('click', this.countClick);
    this.$store.dispatch('startPlayer');
  },
  methods: {
    onTimeUpdate(time) {
      this.$store.dispatch('setCurrentPlayerTime', parseInt(time));
    },
    onStartPlayer() {
      this.$store.dispatch('startPlayer');
    },
    onPausePlayer() {
      this.$store.dispatch('pausePlayer');
    },
    setPosToCurrentTime() {
      let d = new Date();
      this.onTimeUpdate(d.getSeconds() + (60 * d.getMinutes()) + (60 * 60 * d.getHours()));
    },
    onTrackSelect(trackId) {
      this.$store.dispatch('setCurrentPlayerTrack', trackId);
    },
    countClick() {
      this.$store.dispatch('clickCount');
    },
    onInfoButtonStateChanged(state) {
      if (state === 'open') {
        this.onPausePlayer();
      } else {
        this.onStartPlayer();
      }
    },
    onStationExit() {
      this.$emit('unloadStation');
    }
  },
  computed: {
    ...mapGetters({
      track: 'getCurrentPlayerTrack',
      tracks: 'getTracks',
      currentTime: 'getCurrentPlayerTime',
      isPlaying: 'getPlayingState',
      infoButton: 'getInfoPage',
    })
  },
  destroyed() {
    document.removeEventListener('click', this.countClick);
  },
};
</script>

<template>
  <div class="page">
    <image-viewer 
      v-bind:current-time="currentTime"
      v-bind:imgBasePath="track.imgbasepath">
    </image-viewer>

    <audio-track-select 
      class="audio-track-select"
      v-bind:tracks="tracks" 
      v-bind:currentTrack="track"
      v-bind:currentTime="currentTime"
      v-on:trackSelected="onTrackSelect($event)">
    </audio-track-select>

    <info-labels v-on:timeUpdated="onTimeUpdate($event)"  />

    <div class="page-controls">
      <info-button class="info-button" v-bind:contentData="infoButton" v-on:stateChanged="onInfoButtonStateChanged" />
      <exit-station-button class="exit-station-button" v-on:stationExited="onStationExit" />
    </div>

    <audio-player 
      v-on:timeUpdated="onTimeUpdate($event)" 
      v-on:playerStarted="onStartPlayer($event)" 
      v-on:playerPaused="onPausePlayer($event)"
      v-bind:currentTime="currentTime"
      v-bind:currentTrack="track"
      v-bind:isPlaying="isPlaying">
    </audio-player>

  </div>
</template>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.audio-track-select {
  position: absolute;
  top: 2.5rem;
  left: 0;
}

.page-controls {
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}

.exit-station-button {
  margin-left: 1rem;
}

.info-labels {
  position: absolute;
  bottom: 13rem;
  left: 0;
}
</style>
